import React, { useRef, Fragment } from 'react';
import axios from 'axios';
import { IFileInfo } from '../type';
import AlertHighLight from './alert-highLight';
import { confirm, alert, calcSize, networkErr, dealWithChildPage, checkFolderExist, formatDate, deleteOSSFile } from '../utils';
import { URL } from '../constants';

const FileInfo = ({
  fileInfo,
  num,
  fileList,
  isOSS,
  setUpdate,
}: {
  fileInfo: IFileInfo;
  num: number;
  fileList: IFileInfo[];
  isOSS: boolean;
  setUpdate: (now: number) => void;
}) => {
  const renameFolderRef = useRef<HTMLInputElement>(null);

  const { isFolder } = fileInfo;

  const downloadFile = (fileInfo: IFileInfo) => {
    if (isFolder) {
      return `${location.origin}${location.pathname}/${fileInfo.filename}`;
    } else {
      if (isOSS) {
        return fileInfo.filePath;
      } else {
        const { pathname } = dealWithChildPage(fileInfo.filename);
        const downloadFileUrl = URL.download.format({ filePath: pathname });
        return downloadFileUrl;
      }
    }
  };

  const deleteFile = (filename: string, originFilename: string) => {
    confirm('提示', <AlertHighLight textFragment={`确定要删除 <span class="delete-alert">${filename}</span> 吗`} />, '确定', function () {
      const { pathname } = dealWithChildPage(filename);
      if (isOSS) {
        return deleteOSSFile(originFilename)
          .then(() => {
            setUpdate(Date.now());
            alert('删除成功');
          })
          .catch((err) => {
            console.error('deleteOSSFile err', err);
            alert('删除失败');
          });
      } else {
        return axios
          .delete(URL.delete.format({ filePath: pathname, isFolder, currentFolder: location.pathname }))
          .then((res: any) => {
            console.info('删除: ', filename);
            if (res.response === 'removed') {
              alert('文件已删除!');
              return;
            } else if (res.response === 'success') {
              // alert("删除成功!");
            } else {
              alert('删除失败!');
            }
          })
          .catch((error) => {
            console.error('删除文件过程中发生了错误', error);
            networkErr(error);
            alert('删除失败!');
          });
      }
    });
  };

  const rename = (value: string) => {
    confirm('重命名', modalElement(value), '确定', () => renameFolder(location.pathname + '/' + value));
    setTimeout(() => {
      renameFolderRef.current!.value = value;
    }, 4);
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.keyCode === 13) {
      renameFolder(location.pathname + '/' + fileInfo.filename);
    }
  };

  const modalElement = (value: string) => {
    return (
      <div className='modal-folder'>
        <div className='content'>
          <input
            size={26}
            placeholder={value}
            className='folder-input-component'
            ref={renameFolderRef}
            //@ts-ignore
            onKeyDown={handleKeyDown}
            autoFocus={true}
          />
        </div>
      </div>
    );
  };

  const renameFolder = (oldPath: string) => {
    let { value } = renameFolderRef.current!;
    const exist = checkFolderExist(fileList, value);
    if (exist) {
      return alert('文件夹已存在');
    }
    value = value.trim();
    if (!value) {
      return alert('请输入文件夹名称');
    }
    if (!/^[\u4e00-\u9fa5\w\s.]+$/.test(value)) {
      return alert('仅支持数字，字母，下划线，点号，汉字和空格');
    }
    const { pathname } = dealWithChildPage(value);
    return axios
      .put(URL.renameFolder, { oldPath, newPath: pathname, currentFolder: location.pathname })
      .then(() => {
        // alert("文件夹重命名成功");
      })
      .catch((err) => {
        alert('文件夹重命名失败');
        console.error('重命名文件夹过程中发生了错误', err);
        networkErr(err);
      });
  };

  const isOSSRootFolder = location.pathname === '/files' && fileInfo.filename === 'OSS';
  return (
    <div className='file-item'>
      <span>{num + 1}. </span>
      {isFolder ? (
        <svg className='folder-icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' width='200' height='200'>
          <path
            d='M810.665 269.333v-24.889c0-27.467-22.288-49.777-49.777-49.777H437.333v-24.89c0-27.467-22.288-49.777-49.779-49.777H263.11c-27.489 0-49.777 22.31-49.777 49.777v99.556h597.332z'
            fill='#2577FF'
          ></path>
          <path
            d='M885.332 269.333H399.999V232c0-41.203-33.431-74.667-74.667-74.667H138.667C97.431 157.333 64 190.798 64 232v597.333C64 870.6 97.431 904 138.667 904h746.665c41.235 0 74.666-33.4 74.666-74.667V344c0-41.202-33.431-74.667-74.666-74.667z'
            fill='#FCB814'
          ></path>
          <path
            d='M344 209.224v60.109h55.528c10.588-82.956-28.514-102.28-62.733-110.843A181.619 181.619 0 0 1 344 209.224zM896.794 270.491C901.296 280.096 904 290.7 904 302v485.334C904 828.6 870.566 862 829.332 862H82.665c-3.93 0-7.71-0.571-11.477-1.156C83.092 886.282 108.73 904 138.665 904h746.667C926.566 904 960 870.6 960 829.333V344c0-37.278-27.454-67.953-63.206-73.509z'
            fill=''
          ></path>
        </svg>
      ) : (
        <svg className='file-icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' width='200' height='200'>
          <path d='M544 128h-288c-19.2 0-32 12.8-32 32v704c0 19.2 12.8 32 32 32h512c19.2 0 32-12.8 32-32v-480h-192c-35.2 0-64-28.8-64-64v-192z m64 12.8v179.2h179.2l-179.2-179.2z m-352-76.8h352c9.6 0 16 3.2 22.4 9.6l224 224c6.4 6.4 9.6 12.8 9.6 22.4v544c0 54.4-41.6 96-96 96h-512c-54.4 0-96-41.6-96-96v-704c0-54.4 41.6-96 96-96z m64 352h160c19.2 0 32 12.8 32 32s-12.8 32-32 32h-160c-19.2 0-32-12.8-32-32s12.8-32 32-32z m0 128h384c19.2 0 32 12.8 32 32s-12.8 32-32 32h-384c-19.2 0-32-12.8-32-32s12.8-32 32-32z m0 128h384c19.2 0 32 12.8 32 32s-12.8 32-32 32h-384c-19.2 0-32-12.8-32-32s12.8-32 32-32z'></path>
        </svg>
      )}
      <a
        title={fileInfo.filename}
        href={downloadFile(fileInfo)}
        target={`${isFolder ? '_self' : '_blank'}`}
        style={{ color: isOSSRootFolder ? '#f26b1f' : '' }}
        className={!isFolder ? 'file-link' : 'file-folder'}
      >
        {fileInfo.filename}
      </a>
      {!isFolder ? (
        <Fragment>
          <span className='file-time'>{formatDate('yyyy-MM-dd hh:mm:ss', fileInfo.atimeMs)}</span>
          <span className='file-size'>{calcSize(fileInfo.fileSize)}</span>
        </Fragment>
      ) : //@prettier-ignore
      isOSS || isOSSRootFolder ? null : (
        <span className='rename-folder' onClick={() => rename(fileInfo.filename)}>
          重命名
        </span>
      )}
      {typeof location && location.hash === '#delete' && !isOSSRootFolder ? (
        <span className='delete-file' onClick={() => deleteFile(fileInfo.filename, fileInfo.originFilename!)}>
          删除
        </span>
      ) : null}
    </div>
  );
};

export default FileInfo;
